import ArrowDropDownIcon from '@mui/icons-material//ArrowDropDown';
import { TableRow } from '@mui/material';
import ExtraActionsMenu from 'components/ExtraActionsMenu';
import theme from 'theme';
import { GenericTableHeadProps } from './GenericTableHead.props';
import { createSortHandler, getSortIconStyle, isActive, orderHandler } from './utilities';
import WidthResizeHandler from '../ValuationsTableHead/WidthResizeHandler';
import {
  StyledTableCell,
  StyledTableHead,
  StyledTableHeadLabel,
  StyledTableSortLabel,
  StyledVisuallyHidden,
} from './index';



const GenericTableHead = ({
  order,
  orderBy,
  onRequestSort,
  columns,
  columnWidths,
  onColumnWidthChange,
}: GenericTableHeadProps) => (
  <StyledTableHead>
    <TableRow>
      {columns.map(headCell => {
        const columnWidth = columnWidths?.[headCell.id];
        return (
          <StyledTableCell
            key={headCell.id}
            align={headCell.align || 'left'}
            sortDirection={orderHandler(headCell.id, false, orderBy, order)}
            style={{
              position: 'relative',
              ...(columnWidth && { width: `${columnWidth}px`, minWidth: `${columnWidth}px` }),
            }}
          >
            {headCell.isSortable && (
              <StyledTableSortLabel
                active={isActive(headCell, orderBy)}
                direction={orderHandler(headCell.id, 'asc', orderBy, order)}
                onClick={createSortHandler(onRequestSort)(headCell.id)}
                slotProps={getSortIconStyle(headCell, orderBy)}
                IconComponent={ArrowDropDownIcon}>
                <StyledTableHeadLabel>{headCell.label}</StyledTableHeadLabel>
                {isActive(headCell, orderBy) && <StyledVisuallyHidden>{`sorted ${order}ending`}</StyledVisuallyHidden>}
              </StyledTableSortLabel>
            )}
            {!headCell.isSortable && (
              <StyledTableHeadLabel>{headCell.label}</StyledTableHeadLabel>
            )}
            {headCell.component === 'actions' && (
              <ExtraActionsMenu 
                options={headCell.options?.map(option => ({
                  ...option,
                  onClick: option.onClick || option.callback
                }))} 
                dotsColor={theme.palette.grey[500]} 
              />
            )}
            {onColumnWidthChange && (
              <WidthResizeHandler
                columnId={headCell.id}
                initialWidth={columnWidth}
                onWidthChange={onColumnWidthChange}
              />
            )}
          </StyledTableCell>
        );
      })}
    </TableRow>
  </StyledTableHead>
);

export default GenericTableHead;
